(() => {
  document.querySelectorAll('#product-accordion').forEach((item) => {
    if (item.dataset.initialized) {
      return;
    }

    item.dataset.initialized = 'true';

    const metafield = item.querySelector('.metafield-multi_line_text_field');

    if (!metafield) {
      return;
    }

    const parent = metafield.closest('.component__accordion-content');

    parent.innerHTML = metafield.textContent.replace('<p></p>', '<br>');

    metafield.remove();

    parent.querySelectorAll('& > *').forEach((item) => {
      if (item.tagName === 'BR') {
        return;
      }

      if (item.textContent.trim() === '') {
        item.remove();
      }
    });
  });
})();
